module.exports = __webpack_public_path__ + "static/media/correct8.944de30f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/correct8.svg
// module id = 315
// module chunks = 0